// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homePageText {
  color: white;
  text-align: center;
  max-width: 40rem;
  margin-top: 4rem;
  background-color: #126fdb;
  border-radius: 1rem;
  text-align: left;
}

.mGridHomePage {
  max-width: 38rem;
  margin: 0 auto;
  margin-top: 4rem;
}

.jointWellFooter {
  display: block;
  color: white;
  text-align: center;
  font-weight: bold;
  max-width: 40rem;
  margin: 0 auto;
  font-size: 0.8rem;
  position: relative;
  bottom: 0.3rem;
  left: 0;
  right: 0;
  margin-top: 4rem;
}

.homePageMainPicture {
  border: 0.5px solid transparent;
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.joint-well-china-paragraph {
  margin: 0 auto;
}

.joint-well-china-header {
  color: #126fdb;
  font-size: 1.6rem;
  margin-left: 1rem;
}
/* 
this is in case we want to do hover
.home-page-box-introduction-c-v {
  border: 1px solid transparent;
  border-radius: 12px;
  transition: 0.3s;
} */

.home-page-box-introduction-c-v {
  border: 1px solid #126fdb;
  border-radius: 12px;
  cursor: pointer;
  position: relative;
  top: 61%;
  background-color: #126fdb;
  transform: translateY(-100%);
}

.home-page-text-header-c-v {
  color: white;
  font-weight: 600;
  font-size: 1.2rem;
}

.home-page-text-header-c-v-2 {
  color: orange;
  font-weight: 600;
  font-size: 1.2rem;
}

.home-page-open-statement-text {
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  margin-left: 0.8rem;
  margin-right: 0.8rem;
}

.joint-well-intro-writing {
  margin-top: 1rem;
  border: 1px solid #126fdb;
  border-radius: 12px;
  max-width: 40rem;
}

.joint-well-intro-text {
  margin-right: 1rem;
}

.home-page-text-font-size {
  font-family: "Manrope", sans-serif;
  font-weight: 500;
}

.home-page-grid-col-each {
  border: 1px solid #126fdb;
  border-radius: 12px;
  cursor: pointer;
  color: white;
  background-color: #126fdb;
  max-height: 11rem;
}

.home-page-flex-col-each {
  background-color: #126fdb;
  cursor: pointer;
  color: white;
  border: 1px solid #126fdb;
  border-radius: 12px;
  max-width: max-content;
}

.home-page-box-for-enter {
  max-width: -moz-fit-content;
  max-width: fit-content;
  margin-left: 4.5rem;
  margin-right: 4.5rem;
}

/* .joint-well-intro-pic {
  border: 2px solid #126fdb;
  border-radius: 12px;
} */

/*Max-width is basically saying 500px, if youre in that this will happen*/
@media all {
  /* xs, extra-small: 0px
  sm, small: 600px
  md, medium: 900px
  lg, large: 1200px
  xl, extra-large: 1536px */

  @media only screen and (min-width: 300px) {
    .homePageText {
      max-width: 18rem;
    }

    /* .home-page-grid-col-each {
      max-width: fit-content;
    } */
    /* .home-page-text-header-c-v {
      font-size: 0.5rem;
    }

    .home-page-text-header-c-v-2 {
      font-size: 0.5rem;
    } */
  }

  @media only screen and (max-width: 349px) {
    .homePageText {
      max-width: 18rem;
    }

    /* .home-page-grid-col-each {
      max-width: fit-content;
    } */
    /* .home-page-text-header-c-v {
      font-size: 0.5rem;
    }

    .home-page-text-header-c-v-2 {
      font-size: 0.5rem;
    } */

    .home-page-text-header-c-v {
      font-size: 1rem;
    }
  }
  /* Extra small devices (phones, 600px and down) */
  @media only screen and (min-width: 500px) {
    .homePageText {
      max-width: 26rem;
    }

    /* .home-page-grid-col-each {
      max-width: fit-content;
    } */
    /* .home-page-text-header-c-v {
      font-size: 0.7rem;
    }

    .home-page-text-header-c-v-2 {
      font-size: 0.7rem;
    } */
  }
  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    .homePageText {
      max-width: 32rem;
    }

    /* .home-page-grid-col-each {
      max-width: fit-content;
    } */
    /* .home-page-text-header-c-v {
      font-size: 0.8rem;
    }

    .home-page-text-header-c-v-2 {
      font-size: 0.8rem;
    } */
  }
  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    .homePageText {
      max-width: 34rem;
    }

    /* .home-page-grid-col-each {
      max-width: fit-content;
    } */

    /* .home-page-text-header-c-v {
      font-size: 0.84rem;
    }

    .home-page-text-header-c-v-2 {
      font-size: 0.84rem;
    } */
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (max-width: 991px) {
    .home-page-grid-col-each {
      max-width: -moz-fit-content;
      max-width: fit-content;
    }
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    .homePageText {
      max-width: 38rem;
    }
    /* .home-page-text-header-c-v {
      font-size: 1rem;
    }

    .home-page-text-header-c-v-2 {
      font-size: 1rem;
    } */

    .home-page-box-for-enter {
      margin-left: 1rem;
      margin-right: 1rem;
    }
  }
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    .homePageText {
      max-width: 49rem;
    }
    .home-page-text-header-c-v {
      font-size: 1rem;
    }

    .home-page-text-header-c-v-2 {
      font-size: 1.2rem;
    }

    .home-page-box-for-enter {
      margin-left: 4.5rem;
      margin-right: 4.5rem;
    }
  }
}

/*Max-width is basically saying 500px, if youre in that this will happen*/
@media all {
  /* xs, extra-small: 0px
  sm, small: 600px
  md, medium: 900px
  lg, large: 1200px
  xl, extra-large: 1536px */

  @media only screen and (min-width: 300px) {
    .joint-well-intro-writing {
      max-width: 18rem;
    }
  }
  /* Extra small devices (phones, 600px and down) */
  @media only screen and (min-width: 500px) {
    .joint-well-intro-writing {
      max-width: 26rem;
    }
  }
  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    .joint-well-intro-writing {
      max-width: 32rem;
    }
  }
  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    .joint-well-intro-writing {
      max-width: 34rem;
    }
  }
  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    .joint-well-intro-writing {
      max-width: 36rem;
    }
  }
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    .joint-well-intro-writing {
      max-width: 50rem;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/Homepage/Homepage.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,OAAO;EACP,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;AACA;;;;;;GAMG;;AAEH;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,2BAAsB;EAAtB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;GAGG;;AAEH,yEAAyE;AACzE;EACE;;;;2BAIyB;;EAEzB;IACE;MACE,gBAAgB;IAClB;;IAEA;;OAEG;IACH;;;;;;OAMG;EACL;;EAEA;IACE;MACE,gBAAgB;IAClB;;IAEA;;OAEG;IACH;;;;;;OAMG;;IAEH;MACE,eAAe;IACjB;EACF;EACA,iDAAiD;EACjD;IACE;MACE,gBAAgB;IAClB;;IAEA;;OAEG;IACH;;;;;;OAMG;EACL;EACA,oEAAoE;EACpE;IACE;MACE,gBAAgB;IAClB;;IAEA;;OAEG;IACH;;;;;;OAMG;EACL;EACA,qDAAqD;EACrD;IACE;MACE,gBAAgB;IAClB;;IAEA;;OAEG;;IAEH;;;;;;OAMG;EACL;;EAEA,qDAAqD;EACrD;IACE;MACE,2BAAsB;MAAtB,sBAAsB;IACxB;EACF;;EAEA,mDAAmD;EACnD;IACE;MACE,gBAAgB;IAClB;IACA;;;;;;OAMG;;IAEH;MACE,iBAAiB;MACjB,kBAAkB;IACpB;EACF;EACA,oEAAoE;EACpE;IACE;MACE,gBAAgB;IAClB;IACA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,mBAAmB;MACnB,oBAAoB;IACtB;EACF;AACF;;AAEA,yEAAyE;AACzE;EACE;;;;2BAIyB;;EAEzB;IACE;MACE,gBAAgB;IAClB;EACF;EACA,iDAAiD;EACjD;IACE;MACE,gBAAgB;IAClB;EACF;EACA,oEAAoE;EACpE;IACE;MACE,gBAAgB;IAClB;EACF;EACA,qDAAqD;EACrD;IACE;MACE,gBAAgB;IAClB;EACF;EACA,mDAAmD;EACnD;IACE;MACE,gBAAgB;IAClB;EACF;EACA,oEAAoE;EACpE;IACE;MACE,gBAAgB;IAClB;EACF;AACF","sourcesContent":[".homePageText {\n  color: white;\n  text-align: center;\n  max-width: 40rem;\n  margin-top: 4rem;\n  background-color: #126fdb;\n  border-radius: 1rem;\n  text-align: left;\n}\n\n.mGridHomePage {\n  max-width: 38rem;\n  margin: 0 auto;\n  margin-top: 4rem;\n}\n\n.jointWellFooter {\n  display: block;\n  color: white;\n  text-align: center;\n  font-weight: bold;\n  max-width: 40rem;\n  margin: 0 auto;\n  font-size: 0.8rem;\n  position: relative;\n  bottom: 0.3rem;\n  left: 0;\n  right: 0;\n  margin-top: 4rem;\n}\n\n.homePageMainPicture {\n  border: 0.5px solid transparent;\n  -webkit-user-drag: none;\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n}\n\n.joint-well-china-paragraph {\n  margin: 0 auto;\n}\n\n.joint-well-china-header {\n  color: #126fdb;\n  font-size: 1.6rem;\n  margin-left: 1rem;\n}\n/* \nthis is in case we want to do hover\n.home-page-box-introduction-c-v {\n  border: 1px solid transparent;\n  border-radius: 12px;\n  transition: 0.3s;\n} */\n\n.home-page-box-introduction-c-v {\n  border: 1px solid #126fdb;\n  border-radius: 12px;\n  cursor: pointer;\n  position: relative;\n  top: 61%;\n  background-color: #126fdb;\n  transform: translateY(-100%);\n}\n\n.home-page-text-header-c-v {\n  color: white;\n  font-weight: 600;\n  font-size: 1.2rem;\n}\n\n.home-page-text-header-c-v-2 {\n  color: orange;\n  font-weight: 600;\n  font-size: 1.2rem;\n}\n\n.home-page-open-statement-text {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 400;\n  margin-left: 0.8rem;\n  margin-right: 0.8rem;\n}\n\n.joint-well-intro-writing {\n  margin-top: 1rem;\n  border: 1px solid #126fdb;\n  border-radius: 12px;\n  max-width: 40rem;\n}\n\n.joint-well-intro-text {\n  margin-right: 1rem;\n}\n\n.home-page-text-font-size {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 500;\n}\n\n.home-page-grid-col-each {\n  border: 1px solid #126fdb;\n  border-radius: 12px;\n  cursor: pointer;\n  color: white;\n  background-color: #126fdb;\n  max-height: 11rem;\n}\n\n.home-page-flex-col-each {\n  background-color: #126fdb;\n  cursor: pointer;\n  color: white;\n  border: 1px solid #126fdb;\n  border-radius: 12px;\n  max-width: max-content;\n}\n\n.home-page-box-for-enter {\n  max-width: fit-content;\n  margin-left: 4.5rem;\n  margin-right: 4.5rem;\n}\n\n/* .joint-well-intro-pic {\n  border: 2px solid #126fdb;\n  border-radius: 12px;\n} */\n\n/*Max-width is basically saying 500px, if youre in that this will happen*/\n@media all {\n  /* xs, extra-small: 0px\n  sm, small: 600px\n  md, medium: 900px\n  lg, large: 1200px\n  xl, extra-large: 1536px */\n\n  @media only screen and (min-width: 300px) {\n    .homePageText {\n      max-width: 18rem;\n    }\n\n    /* .home-page-grid-col-each {\n      max-width: fit-content;\n    } */\n    /* .home-page-text-header-c-v {\n      font-size: 0.5rem;\n    }\n\n    .home-page-text-header-c-v-2 {\n      font-size: 0.5rem;\n    } */\n  }\n\n  @media only screen and (max-width: 349px) {\n    .homePageText {\n      max-width: 18rem;\n    }\n\n    /* .home-page-grid-col-each {\n      max-width: fit-content;\n    } */\n    /* .home-page-text-header-c-v {\n      font-size: 0.5rem;\n    }\n\n    .home-page-text-header-c-v-2 {\n      font-size: 0.5rem;\n    } */\n\n    .home-page-text-header-c-v {\n      font-size: 1rem;\n    }\n  }\n  /* Extra small devices (phones, 600px and down) */\n  @media only screen and (min-width: 500px) {\n    .homePageText {\n      max-width: 26rem;\n    }\n\n    /* .home-page-grid-col-each {\n      max-width: fit-content;\n    } */\n    /* .home-page-text-header-c-v {\n      font-size: 0.7rem;\n    }\n\n    .home-page-text-header-c-v-2 {\n      font-size: 0.7rem;\n    } */\n  }\n  /* Small devices (portrait tablets and large phones, 600px and up) */\n  @media only screen and (min-width: 600px) {\n    .homePageText {\n      max-width: 32rem;\n    }\n\n    /* .home-page-grid-col-each {\n      max-width: fit-content;\n    } */\n    /* .home-page-text-header-c-v {\n      font-size: 0.8rem;\n    }\n\n    .home-page-text-header-c-v-2 {\n      font-size: 0.8rem;\n    } */\n  }\n  /* Medium devices (landscape tablets, 768px and up) */\n  @media only screen and (min-width: 768px) {\n    .homePageText {\n      max-width: 34rem;\n    }\n\n    /* .home-page-grid-col-each {\n      max-width: fit-content;\n    } */\n\n    /* .home-page-text-header-c-v {\n      font-size: 0.84rem;\n    }\n\n    .home-page-text-header-c-v-2 {\n      font-size: 0.84rem;\n    } */\n  }\n\n  /* Medium devices (landscape tablets, 768px and up) */\n  @media only screen and (max-width: 991px) {\n    .home-page-grid-col-each {\n      max-width: fit-content;\n    }\n  }\n\n  /* Large devices (laptops/desktops, 992px and up) */\n  @media only screen and (min-width: 992px) {\n    .homePageText {\n      max-width: 38rem;\n    }\n    /* .home-page-text-header-c-v {\n      font-size: 1rem;\n    }\n\n    .home-page-text-header-c-v-2 {\n      font-size: 1rem;\n    } */\n\n    .home-page-box-for-enter {\n      margin-left: 1rem;\n      margin-right: 1rem;\n    }\n  }\n  /* Extra large devices (large laptops and desktops, 1200px and up) */\n  @media only screen and (min-width: 1200px) {\n    .homePageText {\n      max-width: 49rem;\n    }\n    .home-page-text-header-c-v {\n      font-size: 1rem;\n    }\n\n    .home-page-text-header-c-v-2 {\n      font-size: 1.2rem;\n    }\n\n    .home-page-box-for-enter {\n      margin-left: 4.5rem;\n      margin-right: 4.5rem;\n    }\n  }\n}\n\n/*Max-width is basically saying 500px, if youre in that this will happen*/\n@media all {\n  /* xs, extra-small: 0px\n  sm, small: 600px\n  md, medium: 900px\n  lg, large: 1200px\n  xl, extra-large: 1536px */\n\n  @media only screen and (min-width: 300px) {\n    .joint-well-intro-writing {\n      max-width: 18rem;\n    }\n  }\n  /* Extra small devices (phones, 600px and down) */\n  @media only screen and (min-width: 500px) {\n    .joint-well-intro-writing {\n      max-width: 26rem;\n    }\n  }\n  /* Small devices (portrait tablets and large phones, 600px and up) */\n  @media only screen and (min-width: 600px) {\n    .joint-well-intro-writing {\n      max-width: 32rem;\n    }\n  }\n  /* Medium devices (landscape tablets, 768px and up) */\n  @media only screen and (min-width: 768px) {\n    .joint-well-intro-writing {\n      max-width: 34rem;\n    }\n  }\n  /* Large devices (laptops/desktops, 992px and up) */\n  @media only screen and (min-width: 992px) {\n    .joint-well-intro-writing {\n      max-width: 36rem;\n    }\n  }\n  /* Extra large devices (large laptops and desktops, 1200px and up) */\n  @media only screen and (min-width: 1200px) {\n    .joint-well-intro-writing {\n      max-width: 50rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
